<!-- <button (click)="test()">Test</button> -->
<div class="container mt-3 mb-3 col-sm-6 text-center">
    <div class="card">
        <div class="card-header">
            Si ya tienes una cuenta <strong>Inicia Sesión</strong>
        </div>
        <div class="card-body">
            <form [formGroup]="forma">
                <div class="row">
                    <div class="col align-self-center">
                        <div class="row">
                            <div class="col mb-3" id="txtEmail">
                                <label for="txtEmail" class="sr-only">Email</label>
                                <input formControlName="email" type="email" id="txtEmail" [ngClass]="{'is-invalid': forma.controls['email']?.errors && !forma.controls['email'].pristine } " class="form-control" placeholder="Dirección de Correo Electrónico" required autofocus>
                                <div class="invalid-feedback">
                                    Escribe un email correcto.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col mb-3">
                                <label for="inputPassword" class="sr-only">Contraseña</label>
                                <input formControlName="password" type="password" id="inputPassword" [ngClass]="{'is-invalid': forma.controls['password']?.errors && !forma.controls['password'].pristine }" class="form-control" placeholder="Contraseña" required>
                                <div class="invalid-feedback">
                                    Escribe un password correcto.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button class="btn btn-lg btn-primary btn-block" [disabled]="forma.invalid" (click)="login()">
                                    <span *ngIf="forma.invalid">Introduce email y password válido</span>
                                    <span *ngIf="forma.valid">Entrar</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
        <div class="card-footer">

        </div>
    </div>
</div>